"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _ToastHost = require("web/shared/components/ToastHost.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One toast on screen: its message, its action when it has one, and its
* dismiss. A temporary toast counts down its remaining time only while
* nobody is on it — the countdown pauses while the pointer is over it,
* while focus is inside it, while the page is hidden, and while its action
* is running — and resumes with what was left, never from the top. A
* plain one goes at a tap; one with an action has a dismiss of its own.
*/
function Toast(props) {
  const request = props.request,
    onDismiss = props.onDismiss;
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pointed = _useState2[0],
    setPointed = _useState2[1];
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  const _useState5 = (0, _react.useState)(typeof document !== "undefined" && document.visibilityState === "hidden"),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    hidden = _useState6[0],
    setHidden = _useState6[1];
  const _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    pending = _useState8[0],
    setPending = _useState8[1];
  const _useState9 = (0, _react.useState)(false),
    _useState0 = (0, _slicedToArray2.default)(_useState9, 2),
    failed = _useState0[0],
    setFailed = _useState0[1]; // What is left of the countdown; spent only while running.
  const remainingRef = (0, _react.useRef)(request.durationMs);
  const dismissRef = (0, _react.useRef)(onDismiss);
  dismissRef.current = onDismiss;
  (0, _react.useEffect)(() => {
    const onVisibility = () => {
      setHidden(document.visibilityState === "hidden");
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);
  const paused = pointed || focused || hidden || pending || props.leaving;
  (0, _react.useEffect)(() => {
    const remaining = remainingRef.current;
    if (paused || remaining == null) {
      return undefined;
    }
    const startedAt = Date.now();
    const timer = setTimeout(() => {
      remainingRef.current = 0;
      dismissRef.current();
    }, remaining);
    return () => {
      clearTimeout(timer);
      remainingRef.current = Math.max(0, remaining - (Date.now() - startedAt));
    };
  }, [paused]);
  const action = request.action;
  const _genActivate = async () => {
    if (action == null || pending) {
      return;
    }
    setPending(true);
    setFailed(false);
    try {
      await action.onActivate();
      onDismiss();
    } catch (actionError) {
      setFailed(true);
    } finally {
      setPending(false);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    role: "status",
    "aria-live": "polite" // A plain toast goes at a tap; one with an action has its dismiss.
    ,
    onClick: action == null ? onDismiss : undefined,
    onMouseEnter: () => setPointed(true),
    onMouseLeave: () => setPointed(false),
    onFocus: () => setFocused(true),
    onBlur: event => {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setFocused(false);
      }
    }
  }, stylex.props(_ToastHost.styles.toast, action != null && _ToastHost.styles.toastWithAction, props.leaving && _ToastHost.styles.toastLeaving)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ToastHost.styles.message)), {}, {
      children: [failed && action != null ? "Could not ".concat(action.label.toLowerCase(), ". ") : "", failed ? null : request.message]
    })), action != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      disabled: pending,
      "aria-busy": pending,
      onClick: () => {
        void _genActivate();
      }
    }, stylex.props(_ToastHost.styles.action, pending && _ToastHost.styles.actionPending)), {}, {
      children: failed ? "Try ".concat(action.label.toLowerCase(), " again") : action.label
    })) : null, action != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      "aria-label": "Dismiss",
      onClick: onDismiss
    }, stylex.props(_ToastHost.styles.dismiss)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: "x-mark",
        size: "xs"
      })
    })) : null]
  }));
}
var _default = exports.default = Toast;